import { LinkedinFilled, GithubFilled, MailOutlined } from "@ant-design/icons";
import { Button } from "antd";

export function PageFooter() {

    function handleOpenNewTab(url: string) {
        window.open(url, "_blank", "noopener noreferrer");
    }

    return (
        <div className="flex flex-col bg-white text-gray-800 justify-center items-center space-y-4 py-6">
            <h1 className="font-dmsans text-lg font-semibold">Let's connect!</h1>
            <div className="flex flex-row justify-center space-x-8 pb-6">
                <a className="border-none shadow-none text-gray-800 hover:text-red-600" onClick={() => handleOpenNewTab("https://www.linkedin.com/in/chaunguyen844/")}>
                    <LinkedinFilled style={{ fontSize: '25px' }}/>
                </a>
                <a className="border-none shadow-none text-gray-800 hover:text-red-600" onClick={() => handleOpenNewTab("https://github.com/chaung844")}>
                    <GithubFilled style={{ fontSize: '25px' }}/>
                </a>
                <a className="border-none shadow-none text-gray-800 hover:text-red-600" onClick={() => handleOpenNewTab("mailto:nguye2cu@mail.uc.edu")}>
                    <MailOutlined style={{ fontSize: '25px' }}/>
                </a>
            </div>
            <h1 className="font-dmsans text-base">Built by Chau Nguyen</h1>
        </div>
    )
}